// ------------------CODED BY ATIQUE----------------------

// import paginationFactory from "react-bootstrap-table2-paginator";
// import BootstrapTable from "react-bootstrap-table-next";
// import cellEditFactory from "react-bootstrap-table2-editor";
// import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import {
  // MDBDataTable,
  // MDBDataTableV5,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Input,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import {
  // Modal,
  // ModalHeader,
  // ModalBody,
  Popover,
  PopoverBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useGetFilter from "../../helpers/hooks/useGetFilter";
// import Pagination from "./extra Components/Pagination";

function LoanList2(props) {
  //   ................By atiq................

  const { status } = useParams();
  const history = useHistory();
  const location = useLocation();

  const loanStatus = [
    {
      value: "Rejected By Bank",
      color: "rgb(251,231,233)",
      status: -2,
    },
    {
      value: "Rejected By Beythak",
      color: "rgba(255, 0, 91, 0.2)",
      status: -1,
    },
    {
      value: "Pending Beythak Approval",
      color: "rgba(254, 192, 0, 0.2)",
      status: 0,
    },
    {
      value: "Pending Bank Approval",
      color: "rgb(255,241,226, 1)",
      status: 1,
    },
    {
      value: "Approved By Bank",
      color: "rgba(0, 200, 139, 0.4)",
      status: 2,
    },
    {
      value: "Under Review",
      color: "rgba(255, 153, 102, 0.4)",
      status: 3,
    },
    {
      value: "All",
      status: "",
    },
  ];

  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  const columns = [
    {
      label: "Loan ID",
      field: "loanId",
      sort: "disabled",
      width: 150,
    },
    {
      label: "Date",
      field: "date",
      sort: "disabled",
      width: 150,
    },
    {
      label: "Name",
      field: "name",
      sort: "asc",
      width: 150,
    },
    {
      label: "CNIC",
      field: "cnic",
      sort: "asc",
      width: 150,
    },
    {
      label: "Phone Number",
      field: "phoneNumber",
      sort: "asc",
      width: 270,
    },
    {
      label: "City",
      field: "city",
      sort: "asc",
      width: 270,
    },
    {
      label: "Loan Amount",
      field: "loanAmount",
      sort: "asc",
      width: 270,
    },

    {
      label: "Score",
      field: "score",
      sort: "asc",
      width: 270,
    },
    {
      label: "Changes Response",
      field: "response",
      sort: "disabled",
      width: 270,
    },
    {
      label: "Loan Status",
      field: "status",
      sort: "asc",
      width: 270,
    },
    {
      label: "Applications",
      field: "applications",
      sort: "disabled",
      width: 270,
    },
    {
      label: bankAdmin ? "User Info" : "Credit Score",
      field: "creditScore",
      sort: "disabled",
      width: 270,
    },
    {
      label: "Financial Statements",
      field: "financialStatements",
      sort: "disabled",
      width: 270,
    },
  ];

  const loanStatusMappings = {
    0: "Pending Beythak Approval",
    "-1": "Rejected By Beythak",
    3: "Under Review",
    "-2": "Rejected By Bank",
    2: "Approved By Bank",
    1: "Pending Bank Approval",
  };

  // States
  const [isLoading, setIsLoading] = useState(false);
  const [isBool, setIsBool] = useState(false);
  const [statusNo, setStatusNo] = useState("");
  const [statusValue, setStatusValue] = useState(status);
  const [tableData, setTableData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchCreatedAt, setSearchCreatedAt] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchCNIC, setSearchCNIC] = useState("");
  const [searchCell, setSearchCell] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchLoanStatus, setSearchLoanStatus] = useState("");
  const [searchScore, setSearchScore] = useState("");
  const [searchResponse, setSearchResponse] = useState("");
  const [searchLoanAmount, setSearchLoanAmount] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [onClickSearchTerm, setOnClickSearchTerm] = useState("");
  const [onClickSearchCreatedAt, setOnClickSearchCreatedAt] = useState("");
  const [onClickSearchName, setOnClickSearchName] = useState("");
  const [onClickSearchCNIC, setOnClickSearchCNIC] = useState("");
  const [onClickSearchCell, setOnClickSearchCell] = useState("");
  const [onClickSearchCity, setOnClickSearchCity] = useState("");
  const [onClickSearchLoanStatus, setOnClickSearchLoanStatus] = useState("");
  const [onClickSearchScore, setOnClickSearchScore] = useState("");
  const [onClickSearchResponse, setOnClickSearchResponse] = useState("");
  const [onClickSearchLoanAmount, setOnClickSearchLoanAmount] = useState("");

  const [popoverOpen, setPopoverOpen] = useState({
    loanId: false,
    date: false,
    name: false,
    cnic: false,
    phoneNumber: false,
    city: false,
    score: false,
    response: false,
    status: false,
    loanAmount: false,
  });

  const togglePopover = (field) => {
    setPopoverOpen((prev) => ({
      ...Object.fromEntries(
        Object.keys(prev).map((key) => [
          key,
          key === field ? !prev[key] : false,
        ])
      ),
    }));
  };

  // Hooks

  const [data, error, loading, call] = useGetFilter(
    `get_loan_applications${
      JSON.parse(localStorage.getItem("bankAdmin")) ? "?bank_status=1" : ""
    }`,
    "loan"
  );

  useEffect(() => {
    if (localStorage.getItem("bankAdmin")) {
      call();
      return;
    }
    for (let x of loanStatus) {
      if (x.value === status) {
        setStatusValue(x.value);
        call(x.status).then((response) => {
          console.log("response dekho pehle", data);
          console.log("Filtered Data Length:", filteredData.length);
        });
      }
    }
  }, [status]);

  useEffect(() => {
    if (data) {
      setDataLoading(false);
      const sortedData = [...data].sort((a, b) => {
        const timestampA = a.loan_application.updatedAt;
        const timestampB = b.loan_application.updatedAt;
        // console.log("Timestamp A:", timestampA);
        // console.log("Timestamp B:", timestampB);
        return new Date(timestampB) - new Date(timestampA);
      });
      // console.log("Sorted Data:", sortedData);
      setTableData(sortedData);
    } else {
      setTableData([]);
    }
  }, [data]);

  // Functions

  const handleSearch = (field, value) => {
    if (value.trim() !== "") {
      if (field === "loanId") {
        setSearchTerm(value);
      } else if (field === "createdAt") {
        setSearchCreatedAt(value);
      } else if (field === "name") {
        setSearchName(value);
      } else if (field === "cnic") {
        setSearchCNIC(value);
      } else if (field === "cellnum") {
        setSearchCell(value);
      } else if (field === "city") {
        setSearchCity(value);
      } else if (field === "status") {
        setSearchLoanStatus(value);
      } else if (field === "score") {
        setSearchScore(value);
      } else if (field === "response") {
        setSearchResponse(value);
      } else if (field === "loanAmount") {
        setSearchLoanAmount(value);
      }
    }
  };

  const filteredData = tableData?.filter((x) => {
    const loanIdMatch = x?.loan_application?.loan_id
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const createdAtMatch = moment(x?.loan_application?.createdAt)
      .format("DD-MM-YYYY")
      .toLowerCase()
      .includes(searchCreatedAt.toLowerCase());
    const nameMatch = x?.user_data?.name
      .toLowerCase()
      .includes(searchName.toLowerCase());
    const cnicMatch = x?.loan_application?.cnic.includes(searchCNIC);
    const phoneMatch = x?.user_data?.phone.includes(searchCell);
    const cityMatch = x?.user_data?.city
      .toLowerCase()
      .includes(searchCity.toLowerCase());
    const loanStatusMatch = loanStatusMappings[x?.loan_application?.loan_status]
      .toLowerCase()
      .includes(searchLoanStatus.toLowerCase());
    const scoreMatch =
      `${x.loan_application.loan_grade}-${x.loan_application.loan_score}`
        .toLowerCase()
        .includes(searchScore.toLowerCase());
    const loanAmountMatch = (x?.loan_application?.preferred_loan_amount || 0)
      .toLocaleString("en-US", { maximumFractionDigits: 0 })
      .includes(
        searchLoanAmount.toLocaleString("en-US", { maximumFractionDigits: 0 })
      );

    const responseMatch =
      (x?.loan_application?.farmer_response === null &&
        !x?.loan_application?.ismodified &&
        "N/A") ||
      (x?.loan_application?.farmer_response === null &&
        x?.loan_application?.ismodified &&
        "Pending...") ||
      (x?.loan_application?.farmer_response === true &&
        !x?.loan_application?.ismodified &&
        "Accepted") ||
      (x?.loan_application?.farmer_response === false &&
        !x?.loan_application?.ismodified &&
        "Rejected") ||
      "";

    const responseTextMatch = responseMatch
      .toLowerCase()
      .includes(searchResponse.toLowerCase());

    const combinedSearchTerm = `${x?.loan_application?.loan_id} ${moment(
      x?.loan_application?.createdAt
    ).format("DD-MM-YYYY")} ${x?.user_data?.name} ${
      x?.loan_application?.cnic
    } ${x?.user_data?.phone} ${x?.user_data?.city} ${
      loanStatusMappings[x?.loan_application?.loan_status]
    } ${x.loan_application.loan_grade}-${x.loan_application.loan_score} ${
      (x?.loan_application?.farmer_response === null &&
        !x?.loan_application?.ismodified &&
        "N/A") ||
      (x?.loan_application?.farmer_response === null &&
        x?.loan_application?.ismodified &&
        "Pending...") ||
      (x?.loan_application?.farmer_response === true &&
        !x?.loan_application?.ismodified &&
        "Accepted") ||
      (x?.loan_application?.farmer_response === false &&
        !x?.loan_application?.ismodified &&
        "Rejected") ||
      ""
    }`.toLowerCase();

    const searchTerms = searchQuery.toLowerCase().split(" ");

    return (
      loanIdMatch &&
      createdAtMatch &&
      nameMatch &&
      cnicMatch &&
      phoneMatch &&
      cityMatch &&
      loanStatusMatch &&
      scoreMatch &&
      responseTextMatch &&
      loanAmountMatch &&
      searchTerms.every((term) => combinedSearchTerm.includes(term))
    );
  });

  const handleGlobalSearch = (searchValue) => {
    setSearchQuery(searchValue);
  };

  const changeStatus = (e) => {
    history.push(`/loan-list/${e.target.value}`);
    // setStatusValue(e.target.value);
    // setTableData([]);

    // history.push({
    //   pathname: "/loan-list/:status",
    //   state: { status: e.target.value },
    // });
  };

  const getStatusTextColor = (status) => {
    switch (status) {
      case -2: // Rejected By Bank
        return "#e06f70";
      case -1: //Rejected By Beythak
        return "#cc0048";
      case 0: // Pending Beythak Approval
        return "#bb8c00";
      case 1: // Pending Bank Approval
        return "#c27046";
      case 2: // Approved By Bank
        return "#00a06f";
      case 3: // Under Review
        return "#cc7a51 ";

      default:
        return "#000"; // Default color
    }
  };

  // console.log(`data ${data}`);

  // States
  // const [currentPage, setCurrentPage] = useState(1);
  // const applicationsPerPage = 3;

  // const lastIndex = currentPage * applicationsPerPage;
  // const firstIndex = lastIndex - applicationsPerPage;
  // const records = filteredData.slice(firstIndex, lastIndex);

  // console.log("datafilter arha to he", filteredData);
  // console.log("tableData arha to he", tableData);

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center">
                  <Spinner className="mr-2" color="primary" />
                </div>
              ) : (
                <div>
                  {!bankAdmin && (
                    <>
                      <MDBRow className="d-flex justify-content-between  mb-2">
                        <MDBCol className=" mt-2 ml-4">
                          <h4>Application status</h4>
                        </MDBCol>
                        <MDBCol sm="6" className="d-flex justify-content-end">
                          <MDBCol sm="8" className="mr-4">
                            <Input
                              type="text"
                              placeholder="Search..."
                              onChange={(e) =>
                                handleGlobalSearch(e.target.value)
                              }
                            />
                          </MDBCol>

                          <MDBCol xs="6" className="mr-3 mt-2 ">
                            <MDBCardText>View:</MDBCardText>
                          </MDBCol>
                          <MDBCol sm="4" className="mr-2">
                            <Input
                              type={"select"}
                              className="text-muted"
                              value={statusValue}
                              onChange={changeStatus}
                            >
                              {loanStatus.map((x) => {
                                console.log(statusValue);
                                return (
                                  <option key={x.value} value={x.value}>
                                    {x.value}
                                  </option>
                                );
                              })}
                            </Input>
                          </MDBCol>
                        </MDBCol>
                      </MDBRow>
                    </>
                  )}

                  <MDBCard>
                    <MDBCardBody id="data-table">
                      {/* {!dataLoading && ( */}
                      <div
                        className="table-responsive table-container2"
                        style={{ borderRadius: "13px" }}
                      >
                        <table className="table table-bordered">
                          <thead
                            style={{
                              // backgroundColor: "rgba(208, 235, 197, 0.6)",
                              backgroundColor: "rgb(246,251,253)",
                            }}
                          >
                            <tr>
                              <th>
                                <i
                                  id="ScheduleUpdateIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("loanId")}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                Loan ID
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.loanId}
                                  target="ScheduleUpdateIcon"
                                  toggle={() => togglePopover("loanId")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search"
                                        value={onClickSearchTerm}
                                        onChange={(e) =>
                                          setOnClickSearchTerm(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "loanId",
                                            onClickSearchTerm
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="DateSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("date")}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                Date
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.date}
                                  target="DateSearchIcon"
                                  toggle={() => togglePopover("date")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search By Date"
                                        value={onClickSearchCreatedAt}
                                        onChange={(e) =>
                                          setOnClickSearchCreatedAt(
                                            e.target.value
                                          )
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "createdAt",
                                            onClickSearchCreatedAt
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="NameSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("name")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Name
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.name}
                                  target="NameSearchIcon"
                                  toggle={() => togglePopover("name")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search name"
                                        value={onClickSearchName}
                                        onChange={(e) =>
                                          setOnClickSearchName(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "name",
                                            onClickSearchName
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="CNICSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("cnic")}
                                  style={{ cursor: "pointer" }}
                                >
                                  {" "}
                                </i>{" "}
                                CNIC
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.cnic}
                                  target="CNICSearchIcon"
                                  toggle={() => togglePopover("cnic")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search CNIC"
                                        value={onClickSearchCNIC}
                                        onChange={(e) =>
                                          setOnClickSearchCNIC(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "cnic",
                                            onClickSearchCNIC
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="PhoneNumberSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("phoneNumber")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Phone Number
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.phoneNumber}
                                  target="PhoneNumberSearchIcon"
                                  toggle={() => togglePopover("phoneNumber")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by phone no."
                                        value={onClickSearchCell}
                                        onChange={(e) =>
                                          setOnClickSearchCell(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "cellnum",
                                            onClickSearchCell
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="CitySearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("city")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                City
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.city}
                                  target="CitySearchIcon"
                                  toggle={() => togglePopover("city")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by city"
                                        value={onClickSearchCity}
                                        onChange={(e) =>
                                          setOnClickSearchCity(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "city",
                                            onClickSearchCity
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="LoanAmountSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("loanAmount")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Loan Amount
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.loanAmount}
                                  target="LoanAmountSearchIcon"
                                  toggle={() => togglePopover("loanAmount")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by loan amount"
                                        value={onClickSearchLoanAmount}
                                        onChange={(e) =>
                                          setOnClickSearchLoanAmount(
                                            e.target.value
                                          )
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "loanAmount",
                                            onClickSearchLoanAmount
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="ScoreSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("score")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Score
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.score}
                                  target="ScoreSearchIcon"
                                  toggle={() => togglePopover("score")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by score"
                                        value={onClickSearchScore}
                                        onChange={(e) =>
                                          setOnClickSearchScore(e.target.value)
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "score",
                                            onClickSearchScore
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>
                              <th>
                                <i
                                  id="ResponseSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("response")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Response
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.response}
                                  target="ResponseSearchIcon"
                                  toggle={() => togglePopover("response")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by response"
                                        value={onClickSearchResponse}
                                        onChange={(e) =>
                                          setOnClickSearchResponse(
                                            e.target.value
                                          )
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "response",
                                            onClickSearchResponse
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>

                              <th>
                                <i
                                  id="StatusSearchIcon"
                                  className="ri-search-line"
                                  onClick={() => togglePopover("status")}
                                  style={{ cursor: "pointer" }}
                                ></i>{" "}
                                Loan Status
                                <Popover
                                  placement="bottom"
                                  isOpen={popoverOpen.status}
                                  target="StatusSearchIcon"
                                  toggle={() => togglePopover("status")}
                                >
                                  <PopoverBody>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        placeholder="Search by response"
                                        value={onClickSearchLoanStatus}
                                        onChange={(e) =>
                                          setOnClickSearchLoanStatus(
                                            e.target.value
                                          )
                                        }
                                      />
                                      <Button
                                        className="ml-2"
                                        style={{
                                          backgroundColor: "#0000ee",
                                          color: "#ffffff",
                                        }}
                                        onClick={() =>
                                          handleSearch(
                                            "status",
                                            onClickSearchLoanStatus
                                          )
                                        }
                                      >
                                        Search
                                      </Button>
                                    </div>
                                  </PopoverBody>
                                </Popover>
                              </th>

                              <th>Applications</th>
                              <th>Credit Score</th>
                              <th>Statements</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredData.length === 0 ? (
                              <tr>
                                <td colSpan="13" className="text-center">
                                  Record Not Found
                                </td>
                              </tr>
                            ) : (
                              //  {
                              filteredData.map((x, index) => (
                                <tr key={index}>
                                  <td>{x?.loan_application?.loan_id}</td>
                                  <td>
                                    {moment(
                                      x?.loan_application?.createdAt
                                    ).format("DD-MM-YYYY")}
                                  </td>
                                  <td>{x?.user_data?.name}</td>
                                  <td>{x?.loan_application?.cnic}</td>
                                  <td>{x?.user_data?.phone}</td>
                                  <td>{x?.user_data?.city}</td>
                                  <td>
                                    Rs.{" "}
                                    {(
                                      x?.loan_application
                                        ?.preferred_loan_amount || 0
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 0,
                                    })}
                                    /-
                                  </td>
                                  <td>{`${x.loan_application.loan_grade}-${x.loan_application.loan_score}`}</td>
                                  <td>
                                    {x?.loan_application?.farmer_response ===
                                    null
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "N/A"
                                        : "Pending..."
                                      : x?.loan_application?.farmer_response ===
                                        true
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "Accepted"
                                        : ""
                                      : x?.loan_application?.farmer_response ===
                                        false
                                      ? x?.loan_application?.ismodified ===
                                        false
                                        ? "Rejected"
                                        : ""
                                      : ""}
                                  </td>

                                  <td>
                                    <Badge
                                      className="font-size-14"
                                      style={{
                                        height: "30%",
                                        color: getStatusTextColor(
                                          x?.loan_application?.loan_status
                                        ),
                                        backgroundColor:
                                          loanStatus[
                                            +x?.loan_application?.loan_status +
                                              2
                                          ]["color"],
                                      }}
                                    >
                                      {
                                        loanStatus[
                                          +x?.loan_application?.loan_status + 2
                                        ]["value"]
                                      }
                                    </Badge>
                                  </td>

                                  <td>
                                    {/* <Link
                                      to={{
                                        pathname: `/loan-detail/${x?.loan_application?._id}/${x?.loan_application?.loan_id}`,
                                        state: x?.loan_application,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      color="primary"
                                    >
                                      View Application
                                    </Link> */}
                                    <Link
                                      to={{
                                        pathname: `/loan-detail/${x?.loan_application?._id}/${x?.loan_application?.loan_id}`,
                                        state: x?.loan_application,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      color="primary"
                                    >
                                      View Application
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname: `/loan-analytics/${x?.loan_application?.loan_id}/${x?.loan_application?._id}`,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      color="primary"
                                    >
                                      {bankAdmin
                                        ? "View User Info"
                                        : "View Credit Score"}
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to={{
                                        pathname: `/loan-financials/${x?.loan_application?.loan_id}/${x?.loan_application?._id}`,
                                      }}
                                      className="waves-effect waves-light mr-1"
                                      color="primary"
                                    >
                                      View Loan Financials
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </MDBCardBody>
                    {/* {filteredData.length > applicationsPerPage && (
                      <Pagination
                        filteredData={filteredData}
                        applicationsPerPage={applicationsPerPage}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    )} */}
                  </MDBCard>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
}

export default LoanList2;
